export default {
  newUser: (state) => state.newUser, 
  single: (state) => (id) => state.users[id] || null,
  users: (state) => state.users,
  userRoles: (state) => state.userRoles,
  newUserACLs: (state) => state.newUserACLs,
}